import { useCartBrand } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useCartBrand";
import { useMemo } from "react";

export const useNumberOfItemsInCart = (brandToken: string): number => {
  const cartBrand = useCartBrand(brandToken);
  const numberOfItemsInCart = useMemo(() => {
    return Object.values(cartBrand?.cart_items ?? {}).length;
  }, [cartBrand]);
  return numberOfItemsInCart;
};
